export default {
  props: {
    validation: {
      default: null
    }
  },
  data () {
    return {
      messageError: []
    }
  },
  computed: {
    isValid () {
      return this.messageError.length === 0
    }
  },
  methods: {
    runValidation () {
      this.messageError = []
      for (let validFunction in this.validation) {
        if (validFunction !== 'group') {
          this[validFunction](this.validation[validFunction])
        }
      }
      return this.messageError.length === 0
    },
    required () {
      const value = this.inputValue.trim().length > 0
      if (!value) this.messageError.push('Campo Obrigatório')
    },
    min (pValue) {
      const value = this.inputValue.trim().length < pValue
      if (value) this.messageError.push(`Deve conter ao menos ${pValue} caracteres`)
    },
    max (pValue) {
      const value = this.inputValue.trim().length > pValue
      if (value) this.messageError.push(`Deve conter no máximo ${pValue} caracteres`)
    },
    valid ({status, message}) {
      if (!status) this.messageError.push(message)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/primitives/validator/validation-mixin/ValidationMixin.js